"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTHORIZE_AVS_RESPONSE = void 0;
const A = 'A';
const B = 'B';
const E = 'E';
const G = 'G';
const N = 'N';
const P = 'P';
const R = 'R';
const S = 'S';
const U = 'U';
const W = 'W';
const X = 'X';
const Y = 'Y';
const Z = 'Z';
exports.AUTHORIZE_AVS_RESPONSE = {
    A,
    B,
    E,
    G,
    N,
    P,
    R,
    S,
    U,
    W,
    X,
    Y,
    Z
};
//# sourceMappingURL=authorizeAVSResponse.js.map